import React from 'react';

const flakes = Array.from({ length: 40 }, (_, i) => ({
  left: (i * 37) % 100,
  size: 2 + (i % 4),
  dur: 9 + (i % 7) * 2,
  delay: -((i * 1.7) % 15),
  op: 0.35 + (i % 5) * 0.12,
}));

export const Snowfall = () => (
  <div className="snowfall" aria-hidden="true">
    {flakes.map((f, i) => (
      <span key={i} className="snowflake" style={{
        left: `${f.left}%`, width: f.size, height: f.size, opacity: f.op,
        animationDuration: `${f.dur}s`, animationDelay: `${f.delay}s`,
      }} />
    ))}
  </div>
);

const bulbs = ['#e6b83f', '#b3262e', '#f7eccf', '#2f6b47', '#e6b83f', '#b3262e', '#f7eccf'];

export const Garland = ({ className = '' }) => (
  <div className={`relative w-full h-14 pointer-events-none ${className}`} aria-hidden="true">
    <svg viewBox="0 0 1200 60" preserveAspectRatio="none" className="absolute inset-0 w-full h-full">
      <path d="M0 6 Q150 50 300 6 T600 6 T900 6 T1200 6" fill="none" stroke="#e6b83f" strokeOpacity=".55" strokeWidth="1.5" />
    </svg>
    <div className="absolute inset-0 flex justify-around items-start">
      {Array.from({ length: 16 }).map((_, i) => {
        const y = Math.abs(Math.sin(((i + 0.5) / 16) * Math.PI * 4)) * 34 + 6;
        return <span key={i} className="xmas-bulb" style={{ marginTop: y, background: bulbs[i % bulbs.length], animationDelay: `${(i % 5) * 0.4}s` }} />;
      })}
    </div>
  </div>
);

export const Ornament = ({ className = '', color = '#e6b83f', size = 48, line = 80 }) => (
  <div className={`absolute flex flex-col items-center ornament-sway pointer-events-none ${className}`} aria-hidden="true">
    <span className="w-px bg-[#e6b83f]/50" style={{ height: line }} />
    <span className="w-3 h-2 bg-[#c79a24] rounded-t-sm" />
    <span className="rounded-full" style={{
      width: size, height: size,
      background: `radial-gradient(circle at 32% 30%, rgba(255,255,255,.65), ${color} 38%, rgba(0,0,0,.55) 100%)`,
      boxShadow: `0 0 24px ${color}55`,
    }} />
  </div>
);

export const StarDivider = () => (
  <div className="flex items-center justify-center gap-4 my-6" aria-hidden="true">
    <span className="h-px w-16 bg-gradient-to-r from-transparent to-[#e6b83f]/70" />
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#e6b83f"><path d="M12 2l2.9 6.9L22 9.3l-5.5 4.7L18.2 21 12 17.3 5.8 21l1.7-7L2 9.3l7.1-.4z" /></svg>
    <span className="h-px w-16 bg-gradient-to-l from-transparent to-[#e6b83f]/70" />
  </div>
);
